module.exports = __webpack_public_path__ + "img/appstore.dc2300b3.png";